import ModalBase from '@/components/ielts/common/ModalBase';
import React from 'react';
import mainIcon from './icon.png';
import Image from 'next/image';
import ButtonIelts, { ButtonColorScheme } from '@/components/common/ButtonIelts';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

type Props = {
  open: boolean;
  onClose?: () => void;
};

export default function RequireLoginModal({ open, onClose }: Props) {
  const { t } = useTranslation('modal');
  const router = useRouter();

  const onClickLoginNow = () => {
    router.push(`/login?auth_redirect_url=${router.asPath}`);
    onClose?.();
  };

  return (
    <ModalBase
      title={
        <span className="uppercase text-white text-[32px]">
          {t('require_login.require_login_title')}
        </span>
      }
      open={open}
      onClose={onClose}
      closeIcon
      wrapClassName="w-[600px]"
    >
      <div className="flex flex-col items-center gap-9">
        <Image
          src={mainIcon}
          alt="icon"
          className="w-[140px] h-auto shrink-0"
          width={460}
          height={441}
        />

        <p className="text-center text-xl">{t('require_login.require_login_description')}</p>

        <ButtonIelts
          onClick={onClickLoginNow}
          typeButton={ButtonColorScheme.Green}
          title={t('require_login.login_now')}
        />
      </div>
    </ModalBase>
  );
}
